import { Injectable, computed, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

export interface SessionUser {
  userName: string;
  displayName: string;
  role: string;
  totpEnabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  readonly user = signal<SessionUser | null>(readUser());
  readonly role = computed(() => this.user()?.role ?? '');
  readonly isField = computed(() => ['Censista', 'Bafi', 'Lecturista'].includes(this.role()));

  constructor(private readonly http: HttpClient, private readonly router: Router) {}

  login(userName: string, password: string, totp = '') {
    return this.http
      .post<{ accessToken: string; user: SessionUser; requiresTotp?: boolean; error?: string }>(
        '/api/auth/login',
        { userName, password, totp },
      )
      .pipe(tap((res) => {
        if (!res.accessToken) return;
        localStorage.setItem('cografa:token', res.accessToken);
        localStorage.setItem('cografa:user', JSON.stringify(res.user));
        this.user.set(res.user);
      }));
  }

  logout(): void {
    localStorage.removeItem('cografa:token');
    localStorage.removeItem('cografa:user');
    this.user.set(null);
    void this.router.navigateByUrl('/sign-in');
  }

  home(): string {
    switch (this.role()) {
      case 'Censista': return '/censos';
      case 'Bafi': return '/bafi/turno';
      case 'Lecturista': return '/pozos';
      case 'Mantenimiento': return '/mantenimiento';
      default: return '/inicio';
    }
  }
}

function readUser(): SessionUser | null {
  try {
    const raw = localStorage.getItem('cografa:user');
    return raw ? (JSON.parse(raw) as SessionUser) : null;
  } catch {
    return null;
  }
}
